'use client';

import { useSyncExternalStore } from 'react';

const subscribe = (): (() => void) => () => {};
const getSnapshot = (): boolean => true;
const getServerSnapshot = (): boolean => false;

/**
 * `false` on the server and during hydration, `true` once the client has taken
 * over. For values that exist only in the browser (storage, the URL) and would
 * otherwise make the first client render disagree with the server's HTML.
 */
export const useIsHydrated = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
